import React, { useState, useEffect } from 'react';
import {
  TextField
} from '@material-ui/core';

export function InputField({ label, name, value, required, onChange, multiline, rows, error, disabled, size }) {
  return (
    <TextField
      label={label}
      name={name}
      value={value || ''}
      required={required}
      fullWidth
      variant="outlined"
      onChange={onChange}
      multiline={multiline || false}
      rows={rows || 3}
      helperText={error}
      error={!!error}
      disabled={disabled}
      size={size}
    />
  );
}

export { default as EditorField } from './EditorField';